//统一管理api
import { base_game } from "./base"; // 导入接口域名列表
import { post } from "./tool"; // 导入http中创建的axios实例

export const subTGGameTweet = (params) => post(base_game + "/apply", params);
export const getTGGameTweetInfo = (params) => post(base_game + "/apply/info", params);

export default { subTGGameTweet, getTGGameTweetInfo };
